import inventoryAPI from '@/services/api/inventory'

const index = {
	namespaced: true,
	state: () => ({
		category: [],
	}),
	getters: {
		getCategoryCount: state => {
			return state.category.length
		},
	},
	mutations: {
		setCategory: (state, payload) => {
			state.category = payload
		},
	},
	actions: {
		loadCategory: async ({ commit }, payload) => {
			const { instId } = payload
			const response = await inventoryAPI.lookupCategory(instId)
			commit('setCategory', response.data)
		},
	},
}
export default index
